<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Coberturas do Endosso
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          TIPO DE ENDOSSO
          <p>{{ getTipoEndosso(idTipoEndosso) }}</p>
        </v-flex>
        <v-flex row wrap> CÓD. COTAÇÃO ENDOSSO </v-flex>
        <v-flex> N. PROPOSTA / ENDOSSO </v-flex>
        <v-flex>DIAS DE VIGÊNCIA ENDOSSO </v-flex>
        <v-flex>RAZÃO SOCIAL </v-flex>
        <v-flex> CNPJ </v-flex>
        <v-flex> QTD. ÍTENS INCLUSÃO </v-flex>
        <v-flex> VLR.ENDOSSO </v-flex>
        <v-flex>
          <br />
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-flex v-if="resultados.totalPremio"
          >PRÊMIO TOTAL
          <p></p>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-form>
        <v-card elevation="0">
          <v-card-title>
            <v-flex xs12 sm11 md6 lg4>
              <transition name="fade">
                <v-flex xs1 v-if="!filtro.pesquisa.opened">
                  <v-btn
                    v-if="!filtro.pesquisa.opened"
                    @click="filtroFunctions().abrirFiltroPesquisa()"
                    color="primary"
                    round
                    outline
                    icon
                    ><v-icon>search</v-icon></v-btn
                  >
                </v-flex>
                <v-flex v-else>
                  <v-text-field
                    v-model="filtro.pesquisa.conteudo"
                    prepend-icon="search"
                    @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                    @blur="filtroFunctions().fecharFiltroPesquisa()"
                    label="Busca"
                    autofocus
                    clearable
                  ></v-text-field>
                </v-flex>
              </transition>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              v-if="((!selected.length && $route.query.idTipoEndosso == 1) && idPropostaStatus != 7)"
              color="primary"
              round
              dark
              @click="dialogAlterarLote = true"
              :disabled="camposDisabled"
              >Alterar em Lote</v-btn
            >
            <v-btn
              v-if="((idTipoEndosso == 1 && !numeroRevisao) && idPropostaStatus != 7)"
              color="error"
              round
              dark
              @click="dialogCobertura = true"
              >Adicionar Coberturas</v-btn
            >

            <v-btn
              @click="deletarItens"
              v-if="(selected.length >= 1 && idPropostaStatus != 7)"
              color="error"
              round
            >
              {{
                selected.length === 1 ? "Excluir Ítem" : "Excluir Ítens"
              }}</v-btn
            >
          </v-card-title>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="errosFiltrados"
            :search="filtro.pesquisa.conteudo"
            :pagination.sync="pagination"
            :select-all="!camposDisabled"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0 text-align-center"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ props.header.text }}
                  </span>
                </template>
                <span v-if="props.header.tool">
                  {{ props.header.tool }}
                </span>
                <span v-else>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template v-slot:items="props">
              <td
                v-if="!camposDisabled"
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <v-checkbox
                  class="checkbox"
                  color="primary"
                  :input-value="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td class="themeGrey--text pa-4">
                {{ formatarNumeroItem(props.item.item) }}
              </td>
              <td class="pa-0 item-faltante">
                <v-tooltip
                  v-if="props.item.erro"
                  right
                  color="error"
                  max-width="350px"
                >
                  <template v-slot:activator="{ on }">
                    <span class="error--text" v-on="on">⬤</span>
                  </template>
                  <span
                    >Não foi possivel avaliar este item devido a um ou mais
                    erros nos dados informados. Consulte a FIPE, corrija o(s)
                    erro(s) direto na linha e clique em "Reavaliar Item" para
                    reprocessar os dados.</span
                  >
                </v-tooltip>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.placa"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.placa
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.placa"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  props.item.placa
                }}</span>
              </td>

              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoCobertura"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.tipoCobertura,
                      campos.tipoCoberturaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoCoberturaList"
                      v-model="props.item.tipoCobertura"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.tipoCobertura,
                    campos.tipoCoberturaList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoDeContratacao"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.tipoDeContratacao,
                      campos.tipoDeContratacaoList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoDeContratacaoList"
                      v-model="props.item.tipoDeContratacao"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.tipoDeContratacao,
                    campos.tipoDeContratacaoList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.percAjusteVmrOuVd"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.percAjusteVmrOuVd
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.percAjusteVmrOuVd"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  props.item.percAjusteVmrOuVd
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoDeFranquia"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.tipoDeFranquia,
                      campos.tipoDeFranquiaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoDeFranquiaList"
                      v-model="props.item.tipoDeFranquia"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.tipoDeFranquia,
                    campos.tipoDeFranquiaList
                  )
                }}</span>
              </td>

              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.vlrFipe"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ formatMoney(props.item.vlrFipe)
                  }}<template v-slot:input>
                    <v-text-field
                      type="number"
                      v-model="props.item.vlrFipe"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  formatMoney(props.item.vlrFipe)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].vdContratado.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vdContratado"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa: erros[props.item.item].vdContratado.erro
                      }"
                      >{{ formatMoney(props.item.vdContratado) }}</span
                    >
                    <template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.vdContratado"
                        label="Editar"
                        single-line
                        :rules="[...regras.notNull]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vdContratado)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].danosMateriais.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.danosMateriais"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa: erros[props.item.item].danosMateriais.erro
                      }"
                      >{{ formatMoney(props.item.danosMateriais) }}</span
                    >
                    <template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.danosMateriais"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.danosMateriais)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.danosMateriais)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].vlrFranquiaDanosMateriais.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vlrFranquiaDanosMateriais"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    >{{
                      props.item.vlrFranquiaDanosMateriais
                        ? formatMoney(props.item.vlrFranquiaDanosMateriais)
                        : "-"
                    }}
                    <template v-slot:input>
                      <v-select
                        :items="campos.vlrFranquiaDanosMateriaisList"
                        v-model="props.item.vlrFranquiaDanosMateriais"
                        item-text="titulo"
                        item-value="titulo"
                        label="Editar"
                        :rules="regras.notNull"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vlrFranquiaDanosMateriais)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].danosCorporais.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.danosCorporais"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa: erros[props.item.item].danosCorporais.erro
                      }"
                      >{{ formatMoney(props.item.danosCorporais) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.danosCorporais"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.danosCorporais)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.danosCorporais)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].danosMoraisEEsteticos.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.danosMoraisEEsteticos"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].danosMoraisEEsteticos.erro
                      }"
                      >{{ formatMoney(props.item.danosMoraisEEsteticos) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.danosMoraisEEsteticos"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.danosMateriais)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.danosMoraisEEsteticos)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.garantiaUnica"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{ buscarTitulo(props.item.garantiaUnica, simOuNao) }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="props.item.garantiaUnica"
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(props.item.garantiaUnica, simOuNao)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].vlrGarantiaUnica.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vlrGarantiaUnica"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa: erros[props.item.item].vlrGarantiaUnica.erro
                      }"
                      >{{ formatMoney(props.item.vlrGarantiaUnica) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.vlrGarantiaUnica"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(
                            limitesTaxasBasicas.vlrGarantiaUnica
                          )
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vlrGarantiaUnica)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].vlrFranquiaGarantiaUnica.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vlrFranquiaGarantiaUnica"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    >{{
                      props.item.vlrFranquiaGarantiaUnica
                        ? formatMoney(props.item.vlrFranquiaGarantiaUnica)
                        : "-"
                    }}
                    <template v-slot:input>
                      <v-select
                        :items="campos.vlrFranquiaGarantiaUnicaList"
                        v-model="props.item.vlrFranquiaGarantiaUnica"
                        item-text="titulo"
                        item-value="titulo"
                        label="Editar"
                        :rules="regras.notNull"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vlrFranquiaGarantiaUnica)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].appMorte.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.appMorte"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa: erros[props.item.item].appMorte.erro
                      }"
                      >{{ formatMoney(props.item.appMorte) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.appMorte"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.appMorte)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.appMorte)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="erros[props.item.item].appInvalidez.ativo">
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.appInvalidez"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa: erros[props.item.item].appInvalidez.erro
                      }"
                      >{{ formatMoney(props.item.appInvalidez) }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.appInvalidez"
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(limitesTaxasBasicas.appInvalidez)
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.appInvalidez)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item]
                      .despesasMedicasHospitalaresEOdontologicas.ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.despesasMedicasHospitalaresEOdontologicas
                    "
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa:
                          erros[props.item.item]
                            .despesasMedicasHospitalaresEOdontologicas.erro
                      }"
                      >{{
                        formatMoney(
                          props.item.despesasMedicasHospitalaresEOdontologicas
                        )
                      }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="
                          props.item.despesasMedicasHospitalaresEOdontologicas
                        "
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(
                            limitesTaxasBasicas.despesasMedicasHospitalaresEOdontologicas
                          )
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(
                      props.item.despesasMedicasHospitalaresEOdontologicas
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item].coberturaAdicionalDespesasExtras
                      .ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.coberturaAdicionalDespesasExtras
                    "
                    lazy
                    large
                    persistent
                    @save="
                      saveDespesasExtras(
                        props.item.item,
                        props.item.coberturaAdicionalDespesasExtras
                      )
                    "
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa:
                          erros[props.item.item]
                            .coberturaAdicionalDespesasExtras.erro
                      }"
                      >{{
                        buscarTitulo(
                          props.item.coberturaAdicionalDespesasExtras,
                          simOuNao
                        )
                      }}</span
                    >
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.coberturaAdicionalDespesasExtras"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.coberturaAdicionalDespesasExtras,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    !erros[props.item.item].desativarCampoDespesasExtras.ativo
                  "
                >
                  <span class="themeGrey--text">{{
                    formatMoney(props.item.despesasExtras)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.caminhaoBasculado"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{ buscarTitulo(props.item.caminhaoBasculado, simOuNao) }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="props.item.caminhaoBasculado"
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(props.item.caminhaoBasculado, simOuNao)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.diasGarantZeroKm"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item.diasGarantZeroKm,
                      campos.diasGarantZeroKmList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.diasGarantZeroKmList"
                      v-model="props.item.diasGarantZeroKm"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.diasGarantZeroKm,
                    campos.diasGarantZeroKmList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item.garantiaCompreensivaParaTumultos
                  "
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item.garantiaCompreensivaParaTumultos,
                      simOuNao
                    )
                  }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="props.item.garantiaCompreensivaParaTumultos"
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.garantiaCompreensivaParaTumultos,
                    simOuNao
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template>
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.extCobAmericaDoSul"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    {{ buscarTitulo(props.item.extCobAmericaDoSul, simOuNao) }}
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.extCobAmericaDoSul"
                        :disabled="
                          props.item.tipoCobertura &&
                            props.item.tipoCobertura.id ===
                              tipoCoberturaComputed.tipoCobertura.RCF
                        "
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(props.item.extCobAmericaDoSul, simOuNao)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template>
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.rcfExtCobAmericaDoSul
                    "
                    lazy
                    large
                    persistent
                    @save="saveRcfExtCobAmericaDoSul(props.item.item,props.item
                      .rcfExtCobAmericaDoSul)"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    {{
                      buscarTitulo(
                        props.item.rcfExtCobAmericaDoSul,
                        simOuNao
                      )
                    }}
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.rcfExtCobAmericaDoSul"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.rcfExtCobAmericaDoSul,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template v-if="!erros[props.item.item].desativarRcfExtCobAmericaDoSul.ativo">

                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.vlrRcfExtCobAmericaDoSul"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    >{{ formatMoney(props.item.vlrRcfExtCobAmericaDoSul)
                    }}<template v-slot:input>
                      <v-text-field
                        v-model="props.item.vlrRcfExtCobAmericaDoSul"
                        label="Editar"
                        disabled
                        single-line
                        :rules="regras.notNull"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(props.item.vlrRcfExtCobAmericaDoSul)
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item
                      .danosMateriaisADirigentesSociosEmpregadosEPrepostos
                  "
                  lazy
                  large
                  persistent
                  @save="
                    saveDmDiregentes(
                      props.item.item,
                      props.item
                        .danosMateriaisADirigentesSociosEmpregadosEPrepostos
                    )
                  "
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item
                        .danosMateriaisADirigentesSociosEmpregadosEPrepostos,
                      simOuNao
                    )
                  }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="
                        props.item
                          .danosMateriaisADirigentesSociosEmpregadosEPrepostos
                      "
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item
                      .danosMateriaisADirigentesSociosEmpregadosEPrepostos,
                    simOuNao
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    !erros[props.item.item]
                      .desativarDanosMateriaisADirigentesSociosEmpregadosEPrepostos
                      .ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.vlrDmDirigenteSociosEmpregadosPrepostos
                    "
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    >{{
                      formatMoney(
                        props.item.vlrDmDirigenteSociosEmpregadosPrepostos
                      )
                    }}<template v-slot:input>
                      <v-text-field
                        v-model="
                          props.item.vlrDmDirigenteSociosEmpregadosPrepostos
                        "
                        label="Editar"
                        single-line
                        :rules="regras.notNull"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(
                      props.item.vlrDmDirigenteSociosEmpregadosPrepostos
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item
                      .danosCorporaisADirigentesSociosEmpregadosEPrepostos
                  "
                  lazy
                  large
                  persistent
                  @save="
                    saveDcDiregentes(
                      props.item.item,
                      props.item
                        .danosCorporaisADirigentesSociosEmpregadosEPrepostos
                    )
                  "
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item
                        .danosCorporaisADirigentesSociosEmpregadosEPrepostos,
                      simOuNao
                    )
                  }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="
                        props.item
                          .danosCorporaisADirigentesSociosEmpregadosEPrepostos
                      "
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item
                      .danosCorporaisADirigentesSociosEmpregadosEPrepostos,
                    simOuNao
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    !erros[props.item.item]
                      .desativarDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                      .ativo
                  "
                >
                  <template
                    v-if="
                      erros[props.item.item]
                        .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                        .ativo
                    "
                  >
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="
                        props.item
                          .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                      "
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      ><span
                        :class="{
                          errorTaxa:
                            erros[props.item.item]
                              .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                              .erro
                        }"
                        >{{
                          formatMoney(
                            props.item
                              .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                          )
                        }}</span
                      ><template v-slot:input>
                        <v-text-field
                          type="number"
                          v-model="
                            props.item
                              .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                          "
                          label="Editar"
                          single-line
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(
                        props.item
                          .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                      )
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item.guDmDcADirigentesSociosEmpregadosEPrepostos
                  "
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item.guDmDcADirigentesSociosEmpregadosEPrepostos,
                      simOuNao
                    )
                  }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="props.item.guDmDcADirigentesSociosEmpregadosEPrepostos"
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.guDmDcADirigentesSociosEmpregadosEPrepostos,
                    simOuNao
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos
                  "
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    formatMoney(
                      props.item.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos
                    )
                  }}<template v-slot:input>
                    <v-text-field
                      type="number"
                      v-model="
                        props.item.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos
                      "
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  formatMoney(
                    props.item.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item]
                      .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                      .ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item
                        .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                    "
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa:
                          erros[props.item.item]
                            .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                            .erro
                      }"
                      >{{
                        formatMoney(
                          props.item
                            .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                        )
                      }}</span
                    ><template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="
                          props.item
                            .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                        "
                        label="Editar"
                        single-line
                        :rules="[
                          ...regras.notNull,
                          ...regras.limites(
                            limitesTaxasBasicas.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                          )
                        ]"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    formatMoney(
                      props.item
                        .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item.extensaoDeCoberturaRcfAVeiculosRebocados
                  "
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{
                    buscarTitulo(
                      props.item.extensaoDeCoberturaRcfAVeiculosRebocados,
                      simOuNao
                    )
                  }}
                  <template v-slot:input>
                    <v-radio-group
                      v-model="
                        props.item.extensaoDeCoberturaRcfAVeiculosRebocados
                      "
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.extensaoDeCoberturaRcfAVeiculosRebocados,
                    simOuNao
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="
                    props.item.vlrExtensaoDeCoberturaRcfAVeiculosRebocados
                  "
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    formatMoney(
                      props.item.vlrExtensaoDeCoberturaRcfAVeiculosRebocados
                    )
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="
                        props.item.vlrExtensaoDeCoberturaRcfAVeiculosRebocados
                      "
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  formatMoney(
                    props.item.vlrExtensaoDeCoberturaRcfAVeiculosRebocados
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item].coberturaAdicionalCarroceria.ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.coberturaAdicionalCarroceria"
                    lazy
                    large
                    persistent
                    @save="
                      saveCarroceria(
                        props.item.item,
                        props.item.coberturaAdicionalCarroceria
                      )
                    "
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].coberturaAdicionalCarroceria
                            .erro
                      }"
                      >{{
                        buscarTitulo(
                          props.item.coberturaAdicionalCarroceria,
                          simOuNao
                        )
                      }}</span
                    >
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.coberturaAdicionalCarroceria"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.coberturaAdicionalCarroceria,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="!erros[props.item.item].desativarCampoCarroceria.ativo"
                >
                  <template
                    v-if="
                      erros[props.item.item].coberturaAdicionalCarroceria.ativo
                    "
                  >
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.descrCarroceria"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{
                        buscarTitulo(
                          props.item.descrCarroceria,
                          campos.descrCarroceriaList
                        )
                      }}
                      <template v-slot:input>
                        <v-select
                          :items="campos.descrCarroceriaList"
                          v-model="props.item.descrCarroceria"
                          item-text="titulo"
                          :item-value="item => item"
                          label="Editar"
                          :rules="regras.notNull"
                          :value-comparator="comparador"
                        ></v-select>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      buscarTitulo(
                        props.item.descrCarroceria,
                        campos.descrCarroceriaList
                      )
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="!erros[props.item.item].desativarCampoCarroceria.ativo"
                >
                  <template
                    v-if="
                      erros[props.item.item].coberturaAdicionalCarroceria.ativo
                    "
                  >
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.vlrCarroceria"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{ formatMoney(props.item.vlrCarroceria)
                      }}<template v-slot:input>
                        <v-text-field
                          v-model="props.item.vlrCarroceria"
                          label="Editar"
                          single-line
                          :rules="regras.notNull"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(props.item.vlrCarroceria)
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item].coberturaAdicionalEquipamentos.ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="
                      props.item.coberturaAdicionalEquipamentos
                    "
                    lazy
                    large
                    persistent
                    @save="
                      saveEquipamentos(
                        props.item.item,
                        props.item.coberturaAdicionalEquipamentos
                      )
                    "
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].coberturaAdicionalEquipamentos
                            .erro
                      }"
                      >{{
                        buscarTitulo(
                          props.item.coberturaAdicionalEquipamentos,
                          simOuNao
                        )
                      }}</span
                    >
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.coberturaAdicionalEquipamentos"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.coberturaAdicionalEquipamentos,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    !erros[props.item.item].desativarCampoEquipamentos.ativo
                  "
                >
                  <template
                    v-if="
                      erros[props.item.item].coberturaAdicionalEquipamentos
                        .ativo
                    "
                  >
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.descrEquipamentos"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{
                        buscarTitulo(
                          props.item.descrEquipamentos,
                          campos.descrEquipamentosList
                        )
                      }}
                      <template v-slot:input>
                        <v-select
                          :items="campos.descrEquipamentosList"
                          v-model="props.item.descrEquipamentos"
                          item-text="titulo"
                          :item-value="item => item"
                          label="Editar"
                          :rules="regras.notNull"
                          :value-comparator="comparador"
                        ></v-select>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      buscarTitulo(
                        props.item.descrEquipamentos,
                        campos.descrEquipamentosList
                      )
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    !erros[props.item.item].desativarCampoEquipamentos.ativo
                  "
                >
                  <template
                    v-if="
                      erros[props.item.item].coberturaAdicionalEquipamentos
                        .ativo
                    "
                  >
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.vlrEquipamentos"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{ formatMoney(props.item.vlrEquipamentos)
                      }}<template v-slot:input>
                        <v-text-field
                          v-model="props.item.vlrEquipamentos"
                          label="Editar"
                          single-line
                          :rules="regras.notNull"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(props.item.vlrEquipamentos)
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="
                    erros[props.item.item].coberturaAdicionalAcessorios.ativo
                  "
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.coberturaAdicionalAcessorios"
                    lazy
                    large
                    persistent
                    @save="
                      saveAcessorios(
                        props.item.item,
                        props.item.coberturaAdicionalAcessorios
                      )
                    "
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    <span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].coberturaAdicionalAcessorios
                            .erro
                      }"
                      >{{
                        buscarTitulo(
                          props.item.coberturaAdicionalAcessorios,
                          simOuNao
                        )
                      }}</span
                    >
                    <template v-slot:input>
                      <v-radio-group
                        v-model="props.item.coberturaAdicionalAcessorios"
                        :mandatory="false"
                        row
                      >
                        <v-radio
                          v-for="item in simOuNao"
                          :key="item.titulo"
                          :label="item.titulo"
                          :value="item.id"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    buscarTitulo(
                      props.item.coberturaAdicionalAcessorios,
                      simOuNao
                    )
                  }}</span>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="!erros[props.item.item].desativarCampoAcessorios.ativo"
                >
                  <template>
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.descrAcessorios"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{
                        buscarTitulo(
                          props.item.descrAcessorios,
                          campos.descrAcessoriosList
                        )
                      }}
                      <template v-slot:input>
                        <v-select
                          :items="campos.descrAcessoriosList"
                          v-model="props.item.descrAcessorios"
                          item-text="titulo"
                          :item-value="item => item"
                          label="Editar"
                          :rules="regras.notNull"
                          :value-comparator="comparador"
                        ></v-select>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      buscarTitulo(
                        props.item.descrAcessorios,
                        campos.descrAcessoriosList
                      )
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="!erros[props.item.item].desativarCampoAcessorios.ativo"
                >
                  <template>
                    <v-edit-dialog
                      class="item-color"
                      :return-value.sync="props.item.vlrAcessorios"
                      lazy
                      large
                      persistent
                      @save="save"
                      @cancel="cancel"
                      @open="open"
                      @close="close"
                      save-text="Salvar"
                      cancel-text="Cancelar"
                      v-if="!camposDisabled"
                      >{{ formatMoney(props.item.vlrAcessorios)
                      }}<template v-slot:input>
                        <v-text-field
                          v-model="props.item.vlrAcessorios"
                          label="Editar"
                          single-line
                          :rules="regras.notNull"
                        ></v-text-field>
                      </template>
                    </v-edit-dialog>
                    <span class="themeGrey--text" v-else>{{
                      formatMoney(props.item.vlrAcessorios)
                    }}</span>
                  </template>
                </template>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.vlrBlindagem"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ formatMoney(props.item.vlrBlindagem)
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.vlrBlindagem"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  formatMoney(props.item.vlrBlindagem)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.vlrKitGas"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ formatMoney(props.item.vlrKitGas)
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.vlrKitGas"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  formatMoney(props.item.vlrKitGas)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.kmAssistencia"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.kmAssistencia,
                      campos.kmAssistenciaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.kmAssistenciaList"
                      v-model="props.item.kmAssistencia"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.kmAssistencia,
                    campos.kmAssistenciaList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.carroReserva"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.carroReserva,
                      campos.carroReservaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.carroReservaList"
                      v-model="props.item.carroReserva"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(props.item.carroReserva, campos.carroReservaList)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-tooltip top v-if="categoriaSemCoberturaVidros(props.item)">
                  <template v-slot:activator="{ on }">
                    <span v-on="on" class="grey--text">Não aplicável</span>
                  </template>
                  <span>Categoria do veículo não possui cobertura de vidros.</span>
                </v-tooltip>
                <v-edit-dialog
                  v-else-if="!camposDisabled"
                  class="item-color"
                  :return-value.sync="props.item.coberturaVidros"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{
                    buscarTitulo(
                      props.item.coberturaVidros,
                      campos.coberturaVidrosList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="opcoesVidros(props.item)"
                      v-model="props.item.coberturaVidros"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.coberturaVidros,
                    campos.coberturaVidrosList
                  )
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoDeProposta"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.tipoDeProposta,
                      campos.tipoDePropostaList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoDePropostaList"
                      v-model="props.item.tipoDeProposta"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(
                    props.item.tipoDeProposta,
                    campos.tipoDePropostaList
                  )
                }}</span>
              </td>
              <td class="themeGrey--text">
                <span class="themeGrey--text" v-if="camposDisabled">{{
                  buscarTitulo(props.item.classeBonus, campos.classeList)
                }}</span>
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.classeBonus"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-else-if="erros[props.item.item].classeBonus.ativo"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].classeBonus.erro
                    }"
                    >{{
                      buscarTitulo(props.item.classeBonus, campos.classeList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.classeList"
                      v-model="props.item.classeBonus"
                      item-text="titulo"
                      item-value="id"
                      label="Editar"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span text-start v-else>0</span>
              </td>

              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].numeroApoliceAnterior.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.numeroApoliceAnterior"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].numeroApoliceAnterior.erro
                      }"
                      >{{ props.item.numeroApoliceAnterior }}</span
                    >
                    <template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.numeroApoliceAnterior"
                        label="Editar"
                        single-line
                        :rules="regras.notNull"
                        mask="###############"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    props.item.numeroApoliceAnterior
                  }}</span>
                </template>
              </td>

              <td class="text-xs-center themeGrey--text">
                <template
                  v-if="erros[props.item.item].numeroItemAnterior.ativo"
                >
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.numeroItemAnterior"
                    lazy
                    large
                    persistent
                    @save="save"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                    ><span
                      :class="{
                        errorTaxa:
                          erros[props.item.item].numeroItemAnterior.erro
                      }"
                      >{{ props.item.numeroItemAnterior }}</span
                    >
                    <template v-slot:input>
                      <v-text-field
                        type="number"
                        v-model="props.item.numeroItemAnterior"
                        label="Editar"
                        single-line
                        :rules="regras.notNull"
                        mask="######"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    props.item.numeroItemAnterior
                  }}</span>
                </template>
              </td>

              <td class="themeGrey--text">
                <span class="themeGrey--text" v-if="camposDisabled">{{
                  buscarTitulo(
                    props.item.renovacaoComSinistro,
                    campos.renovacaoSinistroOptions
                  )
                }}</span>
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.renovacaoComSinistro"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-else-if="erros[props.item.item].renovacaoComSinistro.ativo"
                >
                  <span
                    :class="{
                      errorTaxa:
                        erros[props.item.item].renovacaoComSinistro.erro
                    }"
                    >{{
                      buscarTitulo(
                        props.item.renovacaoComSinistro,
                        campos.renovacaoSinistroOptions
                      )
                    }}</span
                  >
                  <template v-slot:input>
                    <v-radio-group
                      v-model="props.item.renovacaoComSinistro"
                      :mandatory="false"
                      row
                    >
                      <v-radio
                        v-for="item in campos.renovacaoSinistroOptions"
                        :key="item.titulo"
                        :label="item.titulo"
                        :value="item.id"
                      ></v-radio>
                    </v-radio-group>
                  </template>
                </v-edit-dialog>
                <span v-else> Não se Aplica </span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.ciaRenovacao"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(
                      props.item.ciaRenovacao,
                      campos.ciaRenovacaoList
                    )
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.ciaRenovacaoList"
                      v-model="props.item.ciaRenovacao"
                      item-text="titulo"
                      :item-value="item => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  buscarTitulo(props.item.ciaRenovacao, campos.ciaRenovacaoList)
                }}</span>
              </td>
              <td class="text-xs-center themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.codRenovacao"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.codRenovacao
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.codRenovacao"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  props.item.codRenovacao
                }}</span>
              </td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua pesquisa não foi encontrada.
              </v-alert>
            </template>
          </v-data-table>
          <v-snackbar  multi-line v-model="snack" :timeout="3500" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false">Fechar</v-btn>
          </v-snackbar>
        </v-card>
      </v-form>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-flex>

        <v-btn
          color="secondary"
          elevation="2"
          max-width="121px"
          width="100"
          right
          @click="totaisCalculados"
          >{{
              (idStatusEndosso == 5 && idTipoEndosso == 3)
                ? "Ver Cálculo"
                : (recalcular ? "Calcular" : "Ver Cálculo")
            }}</v-btn
        >
      </v-flex>
    </v-layout>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialogCobertura" hide-overlay fullscreen>
          <AdicionarItemEndossoModal
            v-if="dialogCobertura"
            @add="dadosPlanilha.push($event), (dialogCobertura = false)"
            :item="proximoIndice"
            :dialog="dialogCobertura"
            @fechar="dialogCobertura = false"
            :campos="campos"
            :alterarValores="false"
            :diferencaObjetos="true"
          />
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogCalculo" max-width="1200px">
          <ModalDeCalculo
            v-if="dialogCalculo"
            :dialog="dialogCalculo"
            :resultados="resultados"
            :statusProposta="camposDisabled"
            :idStatus="idStatusEndosso"
            :camposInfoGerais="camposInfoGerais"
            @fechar="dialogCalculo = false"
            @ativarLoader="loaderPagina = true"
            @desativarLoader="loaderPagina = false"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-dialog
        persistent
        v-model="loaderPagina"
        width="500"
        content-class="elevation-0"
      >
        <v-card>
          <v-container style="background-color: #FFF;height: 100px;">
            <v-layout
              row
              wrap
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-flex md12 class="text-subtitle-1 text-center">
                <p
                  style="font-weight: bold; margin-bottom: 0; text-align: center"
                >
                  Processando, aguarde...
                </p>
              </v-flex>
              <v-flex md12>
                <v-progress-linear
                  :indeterminate="true"
                  color="primary"
                  height="6"
                  value="15"
                ></v-progress-linear>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="dialogAlterarLote" persistent width="300">
        <v-card class="dialog-alterar-lote">
          <v-card-title
            class="headline alterar-lote-titulo lighten-2 pa-3"
            primary-title
          >
            Alterar em Lote
          </v-card-title>
          <v-divider></v-divider>
          <v-container>
            <div class="conteudo-dialog">
              <div
                class="step-dialog-alterar-1"
                v-show="stepAlterarItemLote === 1"
              >
                <v-select
                  v-model="listaSelecionadoAlteracaoLote"
                  :items="listaItensAlterarLote"
                  label="Itens"
                  item-value="id"
                  item-text="titulo"
                  hint="Selecione os itens a serem alterados."
                  persistent-hint
                  multiple
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item.titulo }} </span>
                    <span v-if="index === 1">{{ item.titulo }} </span>
                    <span v-if="index === 2">
                      (+{{ listaSelecionadoAlteracaoLote.length - 2 }} outros)
                    </span>
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-tile
                      ripple
                      @click="selectionarTodosItensAlteracaoLote"
                    >
                      <v-list-tile-action>
                        <v-icon
                          style="color: #00456e"
                          class="material-icons-outlined"
                        >
                          {{ iconeSelecionarTodos }}
                        </v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Selecionar todos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </div>
            </div>
            <div
              class="step-dialog-alterar-2"
              v-show="stepAlterarItemLote === 2"
            >
              <v-select
                v-model="selecaoIdOpcaoAlteracaoLote"
                :items="
                  agrupamentoOpcoesAlteracaoLoteModel.opcaoAlteracaoLoteEntityList
                "
                item-value="id"
                item-text="titulo"
                label="Coluna"
                hint="Selecione a coluna a ser alterada."
                persistent-hint
                v-show="!habilitarOpcaoGU"
              ></v-select>
              <v-select
                v-model="selecionarIdOpcaoGu"
                :items="opcaoGarantiaUnica"
                v-show="habilitarOpcaoGU"
                item-value="id"
                item-text="titulo"
                label="Nova opção"
                hint="Selecione a opção atualizada."
                persistent-hint
              ></v-select>
            </div>
            <div
              class="step-dialog-alterar-3"
              v-show="stepAlterarItemLote === 3"
            >
              <v-select
                label="Tipo de cobertura"
                item-text="titulo"
                item-value="id"
                v-show="habilitaStepTipoCobertura && !habilitaStepKmAssistencia"
                v-model="idTipoCoberturaAlteracaoLote"
                :items="agrupamentoOpcoesAlteracaoLoteModel.opcaoTipoCobertura"
              ></v-select>
              <v-text-field
                v-model="novoValorAlteracaoLoteFiltrado"
                hint="Informe o valor atualizado"
                label="Novo Valor"
                ref="novoValorCampo"
                v-money="maskComputed.maskMoney"
                persistent-hint
                v-show="
                  !exibirHabilitarFranquiaGu &&
                    !exibirHabilitarFranquiaDm &&
                    !habilitaStepTipoCobertura &&
                    !habilitaStepKmAssistencia
                "
              ></v-text-field>
              <v-select
                v-model="vlrOpcaoValorFranquiaGu"
                :items="campos.vlrFranquiaGarantiaUnicaList"
                item-value="titulo"
                v-show="exibirHabilitarFranquiaGu"
                label="Novo valor"
                item-text="titulo"
              ></v-select>
              <v-select
                v-model="vlrOpcaoValorFranquiaDm"
                :items="campos.vlrFranquiaDanosMateriaisList"
                item-value="titulo"
                v-show="exibirHabilitarFranquiaDm"
                label="Novo valor"
                item-text="titulo"
              ></v-select>
              <v-select
                label="KM Assistência"
                item-text="titulo"
                item-value="id"
                hint="Selecione a opção atualizada"
                persistent-hint
                v-show="habilitaStepKmAssistencia"
                v-model="idKmAssistenciaAlteracaoLote"
                :items="agrupamentoOpcoesAlteracaoLoteModel.opcaoKmAssistencia"
              ></v-select>
            </div>
            <div
              class="step-dialog-alterar-4"
              v-show="stepAlterarItemLote === 4"
            >
              <v-select
                label="Tipo de contratação"
                item-text="titulo"
                item-value="id"
                v-model="idTipoContratacaoAlteracaoLote"
                :items="
                  agrupamentoOpcoesAlteracaoLoteModel.tipoDeContratacaoEntities
                "
              ></v-select>
            </div>
            <div
              class="step-dialog-alterar-5"
              v-show="stepAlterarItemLote === 5"
            >
              <v-text-field
                v-model="novoValorPercentual"
                label="Percentual de ajuste VMR/VD"
                placeholder="%"
                ref="novoValorPercentual"
                type="number"
                persistent-hint
              ></v-text-field>
            </div>
            <div
              class="step-dialog-alterar-5"
              v-show="stepAlterarItemLote === 6"
            >
              <v-text-field
                v-model="novoValorAlteracaoLoteVdContratadoFiltrado"
                hint="Informe o valor atualizado"
                label="VD Contratado"
                ref="novoValorCampoVdContratado"
                v-money="maskComputed.maskMoney"
                persistent-hint
              ></v-text-field>
            </div>
            <div
              class="step-dialog-alterar-6"
              v-show="stepAlterarItemLote === 7"
            >
              <v-select
                label="Tipo de franquia"
                item-text="titulo"
                item-value="id"
                v-model="idTipoFranquiaAlteracaoLote"
                :items="
                  agrupamentoOpcoesAlteracaoLoteModel.tipoDeFranquiaEntities
                "
              ></v-select>
            </div>

            <div class="btn-controle-dialog mt-4">
              <v-btn
                v-show="stepAlterarItemLote === 1"
                color="primary"
                block
                :disabled="disableProximoEscolherItemAlteracaoLote"
                @click="stepAlterarItemLote++"
              >
                PRÓXIMO
              </v-btn>
              <v-btn
                v-show="exibirProximoColunasOpcao"
                color="primary"
                block
                :disabled="disableProximoEscolherOpcaoAlteracaoLote"
                @click="tratamentoSelecaoColuna()"
              >
                PRÓXIMO
              </v-btn>
              <v-btn
                v-show="exibirHabilitarGu"
                color="primary"
                block
                :disabled="disableProximoEscolherOpcaoGuAlteracaoLote"
                @click="tratamentoOpcaoGu()"
              >
                PRÓXIMO
              </v-btn>
              <v-btn
                v-show="exibirProximoCompreensiva"
                color="primary"
                block
                :disabled="disableProximoCompreensiva"
                @click="tratamentoOpcaoCobertura()"
              >
                PRÓXIMO
              </v-btn>
              <v-btn
                v-show="exibirProximoContratacao"
                color="primary"
                block
                :disabled="idTipoContratacaoAlteracaoLote === null"
                @click="tratamentoOpcaoContratacao()"
              >
                PRÓXIMO
              </v-btn>
              <v-btn
                v-show="exibirProximoPercentual"
                color="primary"
                block
                :disabled="!novoValorPercentual"
                @click="tratamentoOpcaoVD()"
              >
                PRÓXIMO
              </v-btn>
              <v-btn
                v-show="exibeProximoVdContratado"
                color="primary"
                block
                :disabled="disableProximoNovoValorAlteracaoLoteVdContratado"
                @click="stepAlterarItemLote++"
              >
                PRÓXIMO
              </v-btn>
              <v-btn
                v-show="exibirAlterarNovoValor"
                color="primary"
                block
                :disabled="disableProximoNovoValorAlteracaoLote"
                @click="dialogConfirmarAlteracaoLote = true"
              >
                ALTERAR
              </v-btn>
              <v-btn
                v-show="exibirAlterarVlrFranquias"
                color="primary"
                block
                :disabled="disableProximoNovoValorFranquiaAlteracaoLote"
                @click="dialogConfirmarAlteracaoLote = true"
              >
                ALTERAR
              </v-btn>
              <v-btn
                v-show="exibirAlterarTipoCobertura"
                color="primary"
                block
                :disabled="idTipoCoberturaAlteracaoLote === null"
                @click="dialogConfirmarAlteracaoLote = true"
              >
                ALTERAR
              </v-btn>
              <v-btn
                v-show="stepAlterarItemLote === 7"
                color="primary"
                block
                :disabled="idTipoFranquiaAlteracaoLote === null"
                @click="dialogConfirmarAlteracaoLote = true"
              >
                ALTERAR
              </v-btn>
              <v-btn
                v-show="exibirAlterarKmAssistencia"
                color="primary"
                block
                :disabled="idKmAssistenciaAlteracaoLote === null"
                @click="dialogConfirmarAlteracaoLote = true"
              >
                ALTERAR
              </v-btn>
              <v-btn
                v-show="stepAlterarItemLote === 1"
                color="primary"
                flat
                outline
                block
                @click="fecharDialogAlteracaoLote"
              >
                CANCELAR
              </v-btn>
              <v-btn
                v-show="stepAlterarItemLote > 1"
                color="primary"
                flat
                outline
                block
                @click="tratamentoStepAlteracaoRetroceder"
              >
                Voltar
              </v-btn>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
        v-model="dialogConfirmarAlteracaoLote"
        style="border-radius: 10px"
        persistent
        max-width="400"
      >
        <v-card-title
          class="headline alterar-lote-titulo lighten-2 pa-3"
          style="font-size: 18px"
          primary-title
        >
          Confirmação
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <v-container>
            <div class="content-confirmacao">
              <p>
                Tem certeza que deseja alterar ou substituir as informações dos
                itens selecionados?
              </p>
            </div>
            <v-card-actions
              style="display: flex; justify-content: space-between"
              class="px-3"
            >
              <v-btn
                color="primary"
                flat
                outline
                @click="dialogConfirmarAlteracaoLote = false"
              >
                Não
              </v-btn>
              <v-btn color="primary" @click="alteracaoDadosLote">
                Sim
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalDeCalculo from "./ModalDeCalculo.vue";
import AdicionarItemEndossoModal from "./AdicionarItemEndossoModal";
import opcoesAlteracaoLote from "@/helpers/alteracao-lote.js";
import opcaoGarantiaUnica from "@/helpers/opcao-garantia-unica.js";
import mask from "@/helpers/mask";
import { VMoney } from "v-money";
import CustomFormat from "@/helpers/custom-format";
import tipoCoberturaEnum from "@/helpers/tipo-cobertura-enum.js";
import opcaoContratacao from "@/helpers/tipo-contratacao-enum.js";
import coberturaVidrosHelper from "@/helpers/cobertura-vidros.js";
import despesasExtrasHelper from "@/helpers/despesas-extras";

export default {
  name: "CoberturaEndosso",
  components: {
    ModalDeCalculo,
    AdicionarItemEndossoModal
  },
  directives: {
    money: VMoney
  },
  data() {
    return {
      recalcular: false,
      listaItensAlterarLote: [],
      habilitaStepTipoCobertura: false,
      habilitaStepKmAssistencia: false,
      habilitaStepTipoContratacao: false,
      idTipoCoberturaAlteracaoLote: null,
      idTipoContratacaoAlteracaoLote: null,
      idTipoFranquiaAlteracaoLote: null,
      idKmAssistenciaAlteracaoLote: null,
      agrupamentoOpcoesAlteracaoLoteModel: {
        opcaoAlteracaoLoteEntityList: [],
        opcaoTipoCobertura: [],
        opcaoKmAssistencia: [],
        tipoDeFranquiaEntities: [],
        tipoDeContratacaoEntities: []
      },
      vlrOpcaoValorFranquiaGu: null,
      vlrOpcaoValorFranquiaDm: null,
      listaOpcaoAlteracaoLote: [],
      opcaoGarantiaUnica: [
        { id: 1, titulo: "Sim" },
        { id: 2, titulo: "Nao" }
      ],
      stepAlterarItemLote: 1,
      habilitarOpcaoGU: false,
      habilitarOpcaoFranquiaGU: false,
      habilitarOpcaoFranquiaDM: false,
      habilitarOpcaoContratacao: false,
      habilitarOpcaoPercentual: false,
      habilitarOpcaoTipoFranquia: false,
      habilitarVdContratado: false,
      selecionarIdOpcaoGu: null,
      disableProximoEscolherItemAlteracaoLote: true,
      disableProximoEscolherOpcaoGuAlteracaoLote: true,
      disableProximoEscolherOpcaoAlteracaoLote: true,
      disableProximoNovoValorAlteracaoLote: true,
      disableProximoNovoValorAlteracaoLoteVdContratado: true,
      dialogConfirmarAlteracaoLote: false,
      novoValorAlteracaoLoteFiltrado: null,
      novoValorAlteracaoLote: null,
      novoValorAlteracaoLoteVdContratadoFiltrado: null,
      novoValorAlteracaoLoteVdContratado: null,
      novoValorPercentual: null,
      selecaoIdOpcaoAlteracaoLote: null,
      dialogAlterarLote: false,
      listaSelecionadoAlteracaoLote: [],
      idApolice: null,
      idTipoEndosso: null,
      loaderPagina: false,
      menu: false,
      filtrarErros: false,
      simOuNao: [
        {
          id: true,
          titulo: "Sim"
        },
        {
          id: false,
          titulo: "Não"
        }
      ],
      headers: [
        { text: "ITEM", align: "center", value: "item", class: "item-primary" },
        { text: "", align: "center", value: "", notSortable: false, class: "pa-0" },
        {
          text: "PLACA",
          align: "center",
          value: "placa"
        },
        { text: "TIPO DE COBERTURA", align: "center", value: "tipoCobertura" },
        { text: "TIPO DE CONTRATAÇÃO", align: "center", value: "tipoDeContratacao" },
        { text: "% AJUSTE VMR/VD", align: "center", value: "percAjusteVmrOuVd" },
        { text: "TIPO DE FRANQUIA", align: "center", value: "tipoDeFranquia" },
        { text: "VLR. FIPE", align: "center", value: "vlrFipe" },
        { text: "VD CONTRATADO", align: "center", value: "vdContratado" },
        { text: "DANOS MATERIAIS", align: "center", value: "danosMateriais" },
        {
          text: "VLR. FRANQUIA DM",
          align: "center",
          value: "vlrFranquiaDanosMateriais"
        },
        { text: "DANOS CORPORAIS", align: "center", value: "danosCorporais" },
        { text: "DANOS MORAIS E ESTÉTICOS", align: "center", value: "danosMoraisEEsteticos" },
        { text: "GARANTIA ÚNICA", align: "center", value: "garantiaUnica" },
        { text: "VLR. GARANTIA ÚNICA", align: "center", value: "vlrGarantiaUnica" },
        {
          text: "VLR. FRANQUIA GARANTIA ÚNICA",
          align: "center",
          value: "vlrFranquiaGarantiaUnica"
        },
        { text: "APP MORTE", align: "center", value: "appMorte" },
        { text: "APP INVALIDEZ", align: "center", value: "appInvalidez" },
        {
          text: "DMHO",
          align: "center",
          value: "despesasMedicasHospitalaresEOdontologicas",
          tool: "DESP. MÉDICAS, HOSPITALARES E ODONTOLÓGICAS"
        },
        {
          text: "AD. DESP. EXTRA",
          align: "center",
          value: "coberturaAdicionalDespesasExtras",
          tool: "COBERTURA ADICIONAL: DESPESAS EXTRAS"
        },
        { text: "DESPESAS EXTRAS", align: "center", value: "despesasExtras" },
        { text: "CAMINHÃO BASCULADO", align: "center", value: "caminhaoBasculado" },
        { text: "DIAS DE GARANTIA ZERO KM", align: "center", value: "diasGarantZeroKm" },
        {
          text: "COMPREENSIVA: TUMULTOS",
          align: "center",
          value: "garantiaCompreensivaParaTumultos",
          tool: "GARANTIA COMPREENSIVA PARA TUMULTOS"
        },
        { text: "EXT. COB. AMÉRICA DO SUL", align: "center", value: "extCobAmericaDoSul" },
        { text: "RCF - EXT. COB. AMÉRICA DO SUL",
          align: "center",
          value: "rcfExtCobAmericaDoSul",
          tool: "RCF - EXT. DE PERÍMETRO PARA AMÉRICA DO SUL"
        },
        { text: "VLR. RCF - EXT. COB. AMÉRICA DO SUL", align: "center", value: "vlrRcfExtCobAmericaDoSul" },
        {
          text: "DANOS MAT. DIRIGENTES ETC",
          align: "center",
          value: "danosMateriaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS MATERIAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS"
        },
        {
          text: "VLR. DANOS MAT. DIRIGENTES ETC",
          align: "center",
          value: "vlrDmDirigenteSociosEmpregadosPrepostos"
        },
        {
          text: "DANOS CORP. DIRIGENTES ETC",
          align: "center",
          value: "danosCorporaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS CORPORAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS"
        },
        {
          text: "VLR. DANOS CORP. DIRIGENTES ETC",
          align: "center",
          value: "vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos"
        },
        { text: "GU DM/DC DIRIGENTES ETC", value: "guDmDcADirigentesSociosEmpregadosEPrepostos" },
        { text: "VLR. GU DM/DC DIRIGENTES ETC", value: "vlrGuDmDcADirigentesSociosEmpregadosEPrepostos" },
        {
          text: "DANOS A TERCEIROS",
          align: "center",
          value: "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado",
          tool: "DANOS MATERIAIS/CORPORAIS, CAUSADO POR REBOQUE/SEMIRREBOQUE DESATRELADO"
        },
        {
          text: "EXT. RCF VEÍC. REBOCADOS",
          align: "center",
          value: "extensaoDeCoberturaRcfAVeiculosRebocados",
          tool: "EXTENSÃO DE COBERTURA RCF A VEÍCULOS REBOCADOS"
        },
        {
          text: "VLR. EXT. RCF VEÍC. REBOCADOS",
          align: "center",
          value: "vlrExtensaoDeCoberturaRcfAVeiculosRebocados"
        },
        {
          text: "AD. CARROCERIA",
          align: "center",
          value: "coberturaAdicionalCarroceria",
          tool: "COBERTURA ADICIONAL: CARROCERIA"
        },
        { text: "DESCR. DA CARROCERIA", align: "center", value: "descrCarroceria" },
        { text: "VLR. CARROCERIA", align: "center", value: "vlrCarroceria" },
        {
          text: "AD. EQUIPAMENTOS",
          align: "center",
          value: "coberturaAdicionalEquipamentos",
          tool: "COBERTURA ADICIONAL: EQUIPAMENTOS"
        },
        { text: "DESCR. DO EQUIPAMENTO", align: "center", value: "descEquipamentos" },
        { text: "VLR. EQUIPAMENTO", align: "center", value: "vlrEquipamentos" },
        {
          text: "AD. ACESSÓRIOS",
          align: "center",
          value: "coberturaAdicionalAcessorios",
          tool: "COBERTURA ADICIONAL: ACESSÓRIOS"
        },
        { text: "DESCR. DO ACESSÓRIO", align: "center", value: "descAcessorios" },
        { text: "VLR. ACESSÓRIO", align: "center", value: "vlrAcessorios" },
        { text: "VLR. BLINDAGEM", align: "center", value: "vlrBlindagem" },
        { text: "VLR. KIT GÁS", align: "center", value: "vlrKitGas" },
        { text: "KM ASSISTÊNCIA", align: "center", value: "kmAssistencia" },
        { text: "CARROS RESERVA", align: "center", value: "carroReserva" },
        { text: "COBERTURA VIDROS", align: "center", value: "coberturaVidros" },
        { text: "TIPO DE PROPOSTA", align: "center", value: "tipoDeProposta" },
        { text: "CLASSE", align: "center", value: "classeBonus" },
        { text: "Nº APÓLICE ANTERIOR", align: "center", value: "numeroApoliceAnterior" },
        { text: "NÚMERO ANTERIOR", align: "center", value: "numeroItemAnterior" },
        { text: "TIPO DE RENOVAÇÃO", align: "center", value: "renovacaoComSinistro" },
        { text: "CIA. RENOVAÇÃO", align: "center", value: "ciaRenovacao" },
        { text: "CÓD. RENOVAÇÃO", align: "center", value: "codRenovacao" },
        { text: "DESP. SALV. CONTENÇÃO SINISTRO", value: "despesasSalvamentoContencaoSinistro" },
        { text: "VLR. DESP. SALV. CONTENÇÃO SINISTRO", value: "vlrDespesasSalvamentoContencaoSinistro" },
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      dialogCobertura: false,
      dialogCalculo: false,
      regras: {
        notNull: [v => !!v || "Você não pode deixar este campo em branco"],
        limites: ({ min, max }) => [
          v =>
            +v === 0 ||
            (v >= min && v <= max) ||
            `O valor precisa ser entre ${min} e ${max}`
        ]
      },
      pagination: {
        sortBy: "name"
      },
      selected: [],
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        }
      },
      camposInfoGerais: {
        formaPagamentoList: [],
        idFormaPagamento: null,
        parcelamentoList: [],
        idParcelamento: null,
        dataPrimeiraParcela: null,
        apoliceIof: null,
        corretagem: null
      },
      campos: {
        ufPernoiteList: [],
        tipoCoberturaList: [],
        tipoDeContratacaoList: [],
        tipoDeFranquiaList: [],
        vlrFranquiaDanosMateriaisList: [],
        tipoDePropostaList: [],
        ciaRenovacaoList: [],
        kmAssistenciaList: [],
        carroReservaList: [],
        descrCarroceriaList: [],
        descrEquipamentosList: [],
        descrAcessoriosList: [],
        coberturaVidrosList: [],
        diasGarantZeroKmList: [],
        classeList: new Array(11).fill({}).map((_, index) => ({
          id: index,
          titulo: `${index}`
        })),
        renovacaoSinistroOptions: [
          {
            id: true,
            titulo: "Com sinistro"
          },
          {
            id: false,
            titulo: "Sem Sinistro"
          }
        ]
      },
      dadosPlanilha: [],
      numeroRevisao: null,
      resultados: {
        totalAp: null,
        totalCoberturaCompensativa: null,
        totalCoberturaRcf: null,
        totalCoberturasAdicionais: null,
        totalFranquiaCoberturaAcessorios: null,
        totalFranquiaCoberturaCarroceria: null,
        totalFranquiaCoberturaCompensativa: null,
        totalFranquiaCoberturaEquipamentos: null,
        totalPremio: null,
        totalServicosAgregados: null
      },
      limitesTaxasBasicas: {
        danosMateriais: {},
        vlrFranquiaDanosMateriais: {},
        danosCorporais: {},
        danosMoraisEEsteticos: {},
        danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado: {},
        appMorte: {},
        appInvalidez: {},
        despesasMedicasHospitalaresEOdontologicas: {},
        vlrGarantiaUnica: {},
        vlrFranquiaGarantiaUnica: {},
        vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos: {}
      },
      idApolice: null,
      idStatusEndosso: null,
      idPropostaStatus: null,
    };
  },

  computed: {
    exibirProximoColunasOpcao() {
      return !this.habilitarOpcaoGU && this.stepAlterarItemLote === 2;
    },
    exibirHabilitarGu() {
      return this.habilitarOpcaoGU && this.stepAlterarItemLote === 2;
    },
    exibirProximoCompreensiva() {
      return (
        this.idTipoCoberturaAlteracaoLote === 1 &&
        this.stepAlterarItemLote === 3
      );
    },
    exibirProximoContratacao() {
      return this.habilitarOpcaoContratacao && this.stepAlterarItemLote === 4;
    },
    exibirProximoPercentual() {
      return this.habilitarOpcaoPercentual && this.stepAlterarItemLote === 5;
    },
    exibeProximoVdContratado() {
      return this.habilitarVdContratado && this.stepAlterarItemLote === 6;
    },
    exibirAlterarNovoValor() {
      return (
        this.stepAlterarItemLote === 3 &&
        !this.habilitarOpcaoFranquiaDM &&
        !this.habilitarOpcaoFranquiaGU &&
        this.habilitaStepTipoCobertura === false &&
        this.habilitaStepKmAssistencia === false
      );
    },
    exibirAlterarKmAssistencia() {
      return this.stepAlterarItemLote === 3 && this.habilitaStepKmAssistencia;
    },
    exibirAlterarVlrFranquias() {
      return (
        this.stepAlterarItemLote === 3 &&
        (this.habilitarOpcaoFranquiaDM === true ||
          this.habilitarOpcaoFranquiaGU === true)
      );
    },
    exibirAlterarTipoCobertura() {
      return (
        this.stepAlterarItemLote === 3 &&
        this.habilitaStepTipoCobertura === true &&
        this.idTipoCoberturaAlteracaoLote !== 1
      );
    },
    exibirHabilitarFranquiaGu() {
      return (
        this.habilitarOpcaoFranquiaGU &&
        this.stepAlterarItemLote === 3 &&
        this.selecaoIdOpcaoAlteracaoLote ===
          opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.FRANQUIA_GARANTIA_UNICA
      );
    },
    exibirHabilitarFranquiaDm() {
      return (
        this.habilitarOpcaoFranquiaDM &&
        this.stepAlterarItemLote === 3 &&
        this.selecaoIdOpcaoAlteracaoLote ===
          opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.FRANQUIA_DANOS_MATERIAIS
      );
    },
    disableProximoCompreensiva() {
      return (
        this.idTipoCoberturaAlteracaoLote !=
        tipoCoberturaEnum.tipoCobertura.COMPREENSIVA
      );
    },
    disableProximoNovoValorFranquiaAlteracaoLote() {
      return (
        this.vlrOpcaoValorFranquiaDm === null &&
        this.vlrOpcaoValorFranquiaGu === null
      );
    },
    maskComputed: function() {
      return mask;
    },
    tipoCoberturaComputed() {
      return tipoCoberturaEnum;
    },
    igualUmItem() {
      return (
        this.listaSelecionadoAlteracaoLote.length > 0 && !this.igualTodosItens
      );
    },
    iconeSelecionarTodos() {
      if (this.igualTodosItens) return "check_box";
      if (this.igualUmItem) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualTodosItens() {
      return (
        this.listaSelecionadoAlteracaoLote.length ===
        this.listaItensAlterarLote.length
      );
    },

    camposDisabled() {
      if (this.idStatusEndosso == 1) {
        return false
       }  else if(this.idStatusEndosso == 8) {
        return false;
       } else if(!this.idStatusEndosso){
        return false;
       } else {
        return true
       }
    },


    ...mapState("formEndosso", [
      "id",
      "proponenteCnpj",
      "proponenteRazaoSocial",
      "quantidadeItens",
      "dateInicio",
      "dateFim",
      "valoresPremioTotal"
    ]),

    errosFiltrados() {
      return this.filtrarErros && this.numeroErros
        ? this.dadosPlanilha.filter(value => value.erro)
        : this.dadosPlanilha;
    },
    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },
    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },

    proximoIndice() {
      return (
        this.dadosPlanilha.reduce(
          (acc, cur) => (cur.item > acc ? cur.item : acc),
          -1
        ) + 1
      );
    },

    textPrimeiraParcela() {
      return new Date(this.calculoDataPrimeiraParcela).toLocaleDateString(
        "pt-BR",
        {
          timeZone: "UTC",
          year: "numeric",
          month: "long",
          day: "numeric"
        }
      );
    },

    erros() {
      const validar = (ativo, temErro) => {
        if (!ativo) {
          return { ativo: false };
        }
        return {
          ativo: true,
          erro: temErro()
        };
      };

      return this.dadosPlanilha.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.item]: {
            danosMateriais: validar(true, () =>
              this.limitesTaxasBasicas.danosMateriais !== undefined
                ? this.limiteExcedido(
                    this.limitesTaxasBasicas.danosMateriais,
                    cur.danosMateriais
                  )
                : {}
            ),
            vlrFranquiaDanosMateriais: validar(
              cur.danosMateriais !== "" && cur.danosMateriais !== null,
              () =>
                this.limitesTaxasBasicas.danosMateriais !== undefined
                  ? this.limiteExcedido(
                      this.limitesTaxasBasicas.danosMateriais,
                      cur.danosMateriais
                    )
                  : {}
            ),
            vlrRcfExtCobAmericaDoSul: validar(
              cur.rcfExtCobAmericaDoSul === true,
              () => cur.vlrRcfExtCobAmericaDoSul = Number(cur.danosMateriais) +
              Number(cur.danosCorporais) + Number(cur.vlrGarantiaUnica)
            ),
            desativarRcfExtCobAmericaDoSul: validar(
              !cur.rcfExtCobAmericaDoSul,
              () => typeof cur.rcfExtCobAmericaDoSul !== "boolean"
            ),
            danosCorporais: validar(true, () =>
              this.limitesTaxasBasicas.danosCorporais !== undefined
                ? this.limiteExcedido(
                    this.limitesTaxasBasicas.danosCorporais,
                    cur.danosCorporais
                  )
                : {}
            ),
            danosMoraisEEsteticos: validar(true, () =>
              this.limitesTaxasBasicas.danosMoraisEEsteticos !== undefined
                ? this.limiteExcedido(
                    this.limitesTaxasBasicas.danosMoraisEEsteticos,
                    cur.danosMoraisEEsteticos
                  )
                : {}
            ),
            appMorte: validar(true, () =>
              this.limitesTaxasBasicas.appMorte !== undefined
                ? this.limiteExcedido(
                    this.limitesTaxasBasicas.appMorte,
                    cur.appMorte
                  )
                : {}
            ),
            appInvalidez: validar(true, () =>
              this.limitesTaxasBasicas.appInvalidez !== undefined
                ? this.limiteExcedido(
                    this.limitesTaxasBasicas.appInvalidez,
                    cur.appInvalidez
                  )
                : {}
            ),
            despesasMedicasHospitalaresEOdontologicas: validar(true, () =>
              this.limitesTaxasBasicas
                .despesasMedicasHospitalaresEOdontologicas !== undefined
                ? this.limiteExcedido(
                    this.limitesTaxasBasicas
                      .despesasMedicasHospitalaresEOdontologicas,
                    cur.despesasMedicasHospitalaresEOdontologicas
                  )
                : {}
            ),
            danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado: validar(
              true,
              () =>
                this.limitesTaxasBasicas
                  .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado !==
                undefined
                  ? this.limiteExcedido(
                      this.limitesTaxasBasicas
                        .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado,
                      cur.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                    )
                  : {}
            ),
            vlrGarantiaUnica: validar(cur.garantiaUnica === true, () =>
              this.limitesTaxasBasicas.vlrGarantiaUnica !== undefined
                ? this.limiteExcedido(
                    this.limitesTaxasBasicas.vlrGarantiaUnica,
                    cur.vlrGarantiaUnica
                  )
                : {}
            ),
            vlrFranquiaGarantiaUnica: validar(cur.garantiaUnica === true, () =>
              this.limitesTaxasBasicas.vlrFranquiaGarantiaUnica !== undefined
                ? this.limiteExcedido(
                    this.limitesTaxasBasicas.vlrFranquiaGarantiaUnica,
                    cur.vlrFranquiaGarantiaUnica
                  )
                : {}
            ),
            vdContratado: validar(
              cur.tipoCobertura &&
                [1, 2, 4].includes(cur.tipoCobertura.id) &&
                cur.tipoDeContratacao &&
                cur.tipoDeContratacao.id === 1,
              () => {}
            ),
            classeBonus: {
              ativo: cur.tipoDeProposta && cur.tipoDeProposta.id !== 2
            },
            vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos: validar(
              true,
              () =>
                this.limitesTaxasBasicas
                  .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos !==
                undefined
                  ? this.limiteExcedido(
                      this.limitesTaxasBasicas
                        .vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos,
                      cur.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
                    )
                  : {}
            ),
            numeroApoliceAnterior: {
              ativo: cur.tipoDeProposta && cur.tipoDeProposta.id !== 2
            },
            numeroItemAnterior: {
              ativo: cur.tipoDeProposta && cur.tipoDeProposta.id !== 2
            },
            extCobAmericaDoSul: validar(
              cur.tipoCobertura &&
                cur.tipoCobertura.id === tipoCoberturaEnum.tipoCobertura.RCF,
              () => (cur.extCobAmericaDoSul = false)
            ),
            renovacaoComSinistro: validar(
              cur.tipoDeProposta &&
                cur.tipoDeProposta.id === 1 &&
                cur.classeBonus > 0,
              () =>
                typeof cur.renovacaoComSinistro !== "boolean"
                  ? this.limiteExcedido(undefined, undefined)
                  : {}
            ),
            desativarCampoCarroceria: validar(
              !cur.coberturaAdicionalCarroceria,
              () =>
                typeof cur.coberturaAdicionalCarroceria !== "boolean"
                  ? this.limiteExcedido(undefined, undefined)
                  : {}
            ),
            desativarCampoEquipamentos: validar(
              !cur.coberturaAdicionalEquipamentos,
              () =>
                typeof cur.coberturaAdicionalEquipamentos !== "boolean"
                  ? this.limiteExcedido(undefined, undefined)
                  : {}
            ),
            desativarCampoAcessorios: validar(
              !cur.coberturaAdicionalAcessorios,
              () =>
                typeof cur.coberturaAdicionalAcessorios !== "boolean"
                  ? this.limiteExcedido(undefined, undefined)
                  : {}
            ),
            desativarCampoDespesasExtras: validar(
              !cur.coberturaAdicionalDespesasExtras,
              () =>
                typeof cur.coberturaAdicionalDespesasExtras !== "boolean"
                  ? this.limiteExcedido(undefined, undefined)
                  : {}
            ),
            desativarDanosMateriaisADirigentesSociosEmpregadosEPrepostos: validar(
              !cur.danosMateriaisADirigentesSociosEmpregadosEPrepostos,
              () =>
                typeof cur.danosMateriaisADirigentesSociosEmpregadosEPrepostos !==
                "boolean"
                  ? this.limiteExcedido(undefined, undefined)
                  : {}
            ),
            desativarDanosCorporaisADirigentesSociosEmpregadosEPrepostos: validar(
              !cur.danosCorporaisADirigentesSociosEmpregadosEPrepostos,
              () =>
                typeof cur.danosCorporaisADirigentesSociosEmpregadosEPrepostos !==
                "boolean"
                  ? this.limiteExcedido(undefined, undefined)
                  : {}
            ),
            ...Object.fromEntries(
              [
                "coberturaAdicionalCarroceria",
                "coberturaAdicionalEquipamentos",
                "coberturaAdicionalAcessorios",
                "coberturaAdicionalDespesasExtras"
              ].map(key => [
                key,
                validar(
                  cur.tipoCobertura && [1, 2, 4].includes(cur.tipoCobertura.id),
                  () =>
                    typeof cur[key] !== "boolean"
                      ? this.limiteExcedido(undefined, undefined)
                      : {}
                )
              ])
            )
          }
        }),
        {}
      );
    }
  },

  watch: {
    novoValorAlteracaoLoteFiltrado(val) {
      if (val != null && val != undefined && val != "") {
        this.novoValorAlteracaoLote = CustomFormat.removeMoneyFormat(val);
        this.disableProximoNovoValorAlteracaoLote = false;
      } else {
        this.disableProximoNovoValorAlteracaoLote = true;
      }
    },
    novoValorAlteracaoLoteVdContratadoFiltrado(val) {
      if (val != null && val != undefined && val != "" && val != "R$ 0,00") {
        this.novoValorAlteracaoLoteVdContratado = CustomFormat.removeMoneyFormat(
          val
        );
        this.disableProximoNovoValorAlteracaoLoteVdContratado = false;
      } else {
        this.disableProximoNovoValorAlteracaoLoteVdContratado = true;
      }
    },
    listaSelecionadoAlteracaoLote(val) {
      if (val.length >= 1) {
        this.disableProximoEscolherItemAlteracaoLote = false;
      } else {
        this.disableProximoEscolherItemAlteracaoLote = true;
      }
    },
    selecaoIdOpcaoAlteracaoLote(val) {
      if (val != null && val != undefined) {
        this.disableProximoEscolherOpcaoAlteracaoLote = false;
      } else {
        this.disableProximoEscolherOpcaoAlteracaoLote = true;
      }
    },
    selecionarIdOpcaoGu(val) {
      if (val != null && val != undefined) {
        this.disableProximoEscolherOpcaoGuAlteracaoLote = false;
      } else {
        this.disableProximoEscolherOpcaoGuAlteracaoLote = true;
      }
    }
  },

  mounted() {
    this.idStatusEndosso = this.$store.getters[
      "formEndosso/infoEndosso"
    ].idStatusEndosso;
    this.recalcular = this.$store.getters[
      "formEndosso/infoEndosso"
    ].recalcular;
    this.idApolice = this.$route.query.id ? this.$route.query.id : 0;
    this.idPropostaStatus = this.$route.query.idPropostaStatus
      ? this.$route.query.idPropostaStatus
      : null;
    this.idTipoEndosso = this.$route.query.idTipoEndosso;
    this.dadosPlanilha = this.$store.getters[
      "formEndosso/cloneItemAdicionadoList"
    ];
    this.numeroRevisao = this.$route.query.numeroRevisao;
    this.buscaLimitesTaxas();
    this.retornarOpcoesColuna();

    this.criarListaItensAlteracaoLote();
    this.buscaOpcoes();
    if(this.idStatusEndosso == 5 && this.idTipoEndosso == 3) {
      this.buscarDadosEndossoExclusao();
    }
  },

  methods: {
    categoriaSemCoberturaVidros(item) {
      return !!(item && item.catVeiculo && item.catVeiculo.id === 6);
    },
    opcoesVidros(item) {
      return coberturaVidrosHelper.filtrarOpcoes(
        this.campos.coberturaVidrosList,
        item && item.catVeiculo
      );
    },

    normalizarVidrosTodosItens() {
      coberturaVidrosHelper.normalizarLista(
        this.dadosPlanilha,
        this.campos.coberturaVidrosList
      );
    },
    buscarDadosEndossoExclusao() {
      const params = {
        page: (this.pagination.page - 1) || 0,
        size: (this.pagination.rowsPerPage) || 10,
        idTipoEndosso: this.idTipoEndosso,
      };

      if (Number.isFinite(Number(this.numeroRevisao))) {
        params.numeroRevisaoEndosso = this.numeroRevisao;
      }
      this.$store.commit("startLoading");
      axios.get(
        `${process.env.URL_APOLICEMS}/v1/listarVeiculos/${this.idApolice}`,
        {
          params,
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      )
      .then((response) => {
        if(this.idStatusEndosso == 5) {
          this.dadosPlanilha = response.data.content
            .filter(
              item =>
                item.itemEndossoRemovido === true
            )
            .map(item => ({
              ...item,
              itemEndossoRemovido: false
            }));
        } else {
          this.dadosPlanilha = response.data.content;
        }

        if(this.itemRemovidoList) {
          const itensRemovidos = new Set(this.itemRemovidoList);
          this.dadosPlanilha = this.dadosPlanilha.map(veiculo => {
            if(itensRemovidos.has(veiculo.item)) {
              return {
                ...veiculo,
                itemEndossoRemovido: true
              };
            }
            return veiculo;
          });
        }

        this.pagination.totalItems = response.data.totalElements;
        this.normalizarVidrosTodosItens();
        despesasExtrasHelper.aplicarValorFixo(
          this.dadosPlanilha,
          this.limitesTaxasBasicas.valorFixoDespesasExtras
        );
      })
      .catch((err) => {
        this.$store.commit("endLoading");
      }).finally(() => {
        this.$store.commit("endLoading");
      });
    },
    disableCamposVlrRcfExtCobAmericaDoSul(item, ativo) {
      if(!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].vlrRcfExtCobAmericaDoSul = null;
      }
    },
    retornarOpcoesColuna() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/retornarOpcaoAlteracaoLote/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(res => {
          return res.data;
        })
        .then(data => {
          this.agrupamentoOpcoesAlteracaoLoteModel = data;
        })
        .catch(err => {
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Retornar listagem de opção de alteração em lote";
        });
    },
    tratamentoOpcaoGu() {
      if (
        this.selecionarIdOpcaoGu ===
        opcaoGarantiaUnica.opcaoGarantiaUnicaEnum.NAO
      ) {
        this.dialogConfirmarAlteracaoLote = true;
      } else if (
        this.selecionarIdOpcaoGu ===
        opcaoGarantiaUnica.opcaoGarantiaUnicaEnum.SIM
      ) {
        this.stepAlterarItemLote++;
      }
    },
    tratamentoOpcaoCobertura() {
      if (
        this.idTipoCoberturaAlteracaoLote ===
        tipoCoberturaEnum.tipoCobertura.COMPREENSIVA
      ) {
        this.habilitarOpcaoContratacao = true;
        this.stepAlterarItemLote++;
      }
    },
    tratamentoOpcaoContratacao() {
      this.habilitarOpcaoPercentual = true;
      if (
        this.idTipoContratacaoAlteracaoLote ===
        opcaoContratacao.tipoContratacao.VD
      ) {
        this.habilitarVdContratado = true;
      }
      this.stepAlterarItemLote++;
    },
    tratamentoOpcaoVD() {
      if (
        this.idTipoContratacaoAlteracaoLote ===
        opcaoContratacao.tipoContratacao.VD
      ) {
        this.habilitarVdContratado = true;
        this.stepAlterarItemLote++;
      } else {
        this.stepAlterarItemLote = 7;
      }
    },
    tratamentoStepAlteracaoRetroceder() {
      this.$refs.novoValorCampo.$el.getElementsByTagName("input")[0].value = 0;
      this.$refs.novoValorPercentual.$el.getElementsByTagName(
        "input"
      )[0].value = 0;
      this.selecionarIdOpcaoGu = null;
      this.habilitaStepTipoContratacao = false;
      this.idTipoFranquiaAlteracaoLote = null;
      this.habilitarOpcaoTipoFranquia = false;
      if (this.stepAlterarItemLote === 3) {
        this.idTipoCoberturaAlteracaoLote = null;
        this.habilitarOpcaoFranquiaDM = false;
        this.habilitarOpcaoFranquiaGU = false;
        this.vlrOpcaoValorFranquiaGu = null;
        this.vlrOpcaoValorFranquiaDm = null;
        this.habilitaStepKmAssistencia = false;
        this.idKmAssistenciaAlteracaoLote = null;
      }
      if (this.stepAlterarItemLote === 2) {
        this.selecaoIdOpcaoAlteracaoLote = null;
      }
      if (this.stepAlterarItemLote === 4) {
        this.habilitarOpcaoContratacao = false;
        this.idTipoContratacaoAlteracaoLote = null;
      }
      if (this.stepAlterarItemLote === 5) {
        this.habilitarOpcaoPercentual = false;
        this.novoValorPercentual = null;
      }
      if (this.stepAlterarItemLote === 6) {
        this.habilitarVdContratado = false;
        this.novoValorAlteracaoLoteVdContratado = null;
        this.$refs.novoValorCampoVdContratado.$el.getElementsByTagName(
          "input"
        )[0].value = 0;
      }
      if (
        this.novoValorAlteracaoLoteVdContratado === null &&
        this.stepAlterarItemLote === 7
      ) {
        this.stepAlterarItemLote--;
      }
      if (this.habilitarOpcaoGU && this.stepAlterarItemLote === 2) {
        this.habilitarOpcaoGU = false;
      } else if (
        this.habilitaStepTipoCobertura &&
        this.stepAlterarItemLote === 3
      ) {
        this.habilitaStepTipoCobertura = false;
        this.stepAlterarItemLote--;
      } else {
        this.stepAlterarItemLote--;
      }
    },
    tratamentoSelecaoColuna() {
      if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.GARANTIA_UNICA
      ) {
        this.habilitarOpcaoGU = true;
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.FRANQUIA_GARANTIA_UNICA
      ) {
        this.habilitarOpcaoFranquiaGU = true;
        this.stepAlterarItemLote++;
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.FRANQUIA_DANOS_MATERIAIS
      ) {
        this.habilitarOpcaoFranquiaDM = true;
        this.stepAlterarItemLote++;
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ==
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.TIPO_COBERTURA
      ) {
        this.habilitaStepTipoCobertura = true;
        this.stepAlterarItemLote = 3;
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ==
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.KM_ASSISTENCIA
      ) {
        this.habilitaStepKmAssistencia = true;
        this.stepAlterarItemLote = 3;
      } else {
        this.stepAlterarItemLote++;
      }
    },
    alteracaoDadosLote() {
      this.$store.commit("startLoading");
      this.tratamentoAlterandoItensLote();
      this.$store.commit("endLoading");
    },
    tratamentoAlterandoItensLote() {
      if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.DANOS_MATERIAIS
      ) {
        for (var im = 0; im < this.dadosPlanilha.length; im++) {
          for (var itemSelecionadoAlteracao of this
            .listaSelecionadoAlteracaoLote) {
            if (this.dadosPlanilha[im].item == itemSelecionadoAlteracao) {
              this.dadosPlanilha[
                im
              ].danosMateriais = this.novoValorAlteracaoLote;
            }
          }
        }
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.DANOS_CORPORAIS
      ) {
        for (var ic = 0; ic < this.dadosPlanilha.length; ic++) {
          for (var itemSelecionadoAlteracao of this
            .listaSelecionadoAlteracaoLote) {
            if (this.dadosPlanilha[ic].item == itemSelecionadoAlteracao) {
              this.dadosPlanilha[
                ic
              ].danosCorporais = this.novoValorAlteracaoLote;
            }
          }
        }
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.DANOS_MORAIS_ESTETICOS
      ) {
        for (var idme = 0; idme < this.dadosPlanilha.length; idme++) {
          for (var itemSelecionadoAlteracao of this
            .listaSelecionadoAlteracaoLote) {
            if (this.dadosPlanilha[idme].item == itemSelecionadoAlteracao) {
              this.dadosPlanilha[
                idme
              ].danosMoraisEEsteticos = this.novoValorAlteracaoLote;
            }
          }
        }
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.GARANTIA_UNICA
      ) {
        if (
          this.selecionarIdOpcaoGu ===
          opcaoGarantiaUnica.opcaoGarantiaUnicaEnum.NAO
        ) {
          for (var guNao = 0; guNao < this.dadosPlanilha.length; guNao++) {
            for (var itemSelecionadoAlteracao of this
              .listaSelecionadoAlteracaoLote) {
              if (this.dadosPlanilha[guNao].item == itemSelecionadoAlteracao) {
                this.dadosPlanilha[guNao].garantiaUnica = false;
                this.dadosPlanilha[guNao].vlrGarantiaUnica = 0;
                this.dadosPlanilha[guNao].vlrFranquiaGarantiaUnica = 0;
                this.dadosPlanilha[guNao].guDmDcADirigentesSociosEmpregadosEPrepostos = false;
                this.dadosPlanilha[guNao].vlrGuDmDcADirigentesSociosEmpregadosEPrepostos = 0;
              }
            }
          }
        } else if (
          this.selecionarIdOpcaoGu ===
          opcaoGarantiaUnica.opcaoGarantiaUnicaEnum.SIM
        ) {
          for (var guSim = 0; guSim < this.dadosPlanilha.length; guSim++) {
            for (var itemSelecionadoAlteracao of this
              .listaSelecionadoAlteracaoLote) {
              if (this.dadosPlanilha[guSim].item == itemSelecionadoAlteracao) {
                this.dadosPlanilha[guSim].garantiaUnica = true;
                this.dadosPlanilha[
                  guSim
                ].vlrGarantiaUnica = this.novoValorAlteracaoLote;
              }
            }
          }
        }
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.FRANQUIA_GARANTIA_UNICA
      ) {
        for (
          var franquiaGu = 0;
          franquiaGu < this.dadosPlanilha.length;
          franquiaGu++
        ) {
          for (var itemSelecionadoAlteracao of this
            .listaSelecionadoAlteracaoLote) {
            if (
              this.dadosPlanilha[franquiaGu].item == itemSelecionadoAlteracao &&
              this.dadosPlanilha[franquiaGu].garantiaUnica
            ) {
              this.dadosPlanilha[
                franquiaGu
              ].vlrFranquiaGarantiaUnica = this.vlrOpcaoValorFranquiaGu;
            }
          }
        }
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.FRANQUIA_DANOS_MATERIAIS
      ) {
        for (
          var franquiaDm = 0;
          franquiaDm < this.dadosPlanilha.length;
          franquiaDm++
        ) {
          for (var itemSelecionadoAlteracao of this
            .listaSelecionadoAlteracaoLote) {
            if (
              this.dadosPlanilha[franquiaDm].item == itemSelecionadoAlteracao &&
              this.dadosPlanilha[franquiaDm].danosMateriais != " " &&
              this.dadosPlanilha[franquiaDm].danosMateriais != "" &&
              this.dadosPlanilha[franquiaDm].danosMateriais != null
            ) {
              this.dadosPlanilha[
                franquiaDm
              ].vlrFranquiaDanosMateriais = this.vlrOpcaoValorFranquiaDm;
            }
          }
        }
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.TIPO_COBERTURA
      ) {
        if (
          this.idTipoCoberturaAlteracaoLote ===
          tipoCoberturaEnum.tipoCobertura.COMPREENSIVA
        ) {
          for (
            var tipoContratacao = 0;
            tipoContratacao < this.dadosPlanilha.length;
            tipoContratacao++
          ) {
            for (var itemSelecionadoAlteracao of this
              .listaSelecionadoAlteracaoLote) {
              if (
                this.dadosPlanilha[tipoContratacao].item ===
                itemSelecionadoAlteracao
              ) {
                this.dadosPlanilha[tipoContratacao].tipoCobertura = {
                  id: tipoCoberturaEnum.tipoCobertura.COMPREENSIVA,
                  titulo: "COMPREENSIVA"
                };
                if (
                  this.idTipoContratacaoAlteracaoLote ===
                  opcaoContratacao.tipoContratacao.VMR
                ) {
                  if (
                    this.dadosPlanilha[tipoContratacao].item ==
                    itemSelecionadoAlteracao
                  ) {
                    this.dadosPlanilha[tipoContratacao].tipoDeContratacao = {
                      id: opcaoContratacao.tipoContratacao.VMR,
                      titulo: "VMR"
                    };
                    this.dadosPlanilha[
                      tipoContratacao
                    ].percAjusteVmrOuVd = this.novoValorPercentual;
                    for (var tipoFranquia of this
                      .agrupamentoOpcoesAlteracaoLoteModel
                      .tipoDeFranquiaEntities) {
                      if (
                        tipoFranquia.id === this.idTipoFranquiaAlteracaoLote
                      ) {
                        this.dadosPlanilha[tipoContratacao].tipoDeFranquia = {
                          id: this.idTipoFranquiaAlteracaoLote,
                          titulo: tipoFranquia.titulo
                        };
                      }
                    }
                  }
                }
                if (
                  this.idTipoContratacaoAlteracaoLote ===
                  opcaoContratacao.tipoContratacao.VD
                ) {
                  if (
                    this.dadosPlanilha[tipoContratacao].item ==
                    itemSelecionadoAlteracao
                  ) {
                    this.dadosPlanilha[tipoContratacao].tipoDeContratacao = {
                      id: opcaoContratacao.tipoContratacao.VD,
                      titulo: "VD"
                    };
                    this.dadosPlanilha[
                      tipoContratacao
                    ].vdContratado = this.novoValorAlteracaoLoteVdContratado;
                    this.dadosPlanilha[
                      tipoContratacao
                    ].percAjusteVmrOuVd = this.novoValorPercentual;
                    for (var tipoFranquia of this
                      .agrupamentoOpcoesAlteracaoLoteModel
                      .tipoDeFranquiaEntities) {
                      if (
                        tipoFranquia.id === this.idTipoFranquiaAlteracaoLote
                      ) {
                        this.dadosPlanilha[tipoContratacao].tipoDeFranquia = {
                          id: this.idTipoFranquiaAlteracaoLote,
                          titulo: tipoFranquia.titulo
                        };
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if (
          this.idTipoCoberturaAlteracaoLote ===
          tipoCoberturaEnum.tipoCobertura.RCF
        ) {
          for (
            var tipoRcf = 0;
            tipoRcf < this.dadosPlanilha.length;
            tipoRcf++
          ) {
            for (var itemSelecionadoAlteracao of this
              .listaSelecionadoAlteracaoLote) {
              if (
                this.dadosPlanilha[tipoRcf].item == itemSelecionadoAlteracao
              ) {
                this.dadosPlanilha[tipoRcf].tipoCobertura = {
                  id: tipoCoberturaEnum.tipoCobertura.RCF,
                  titulo: "RCF"
                };
                this.dadosPlanilha[tipoRcf].vdContratado = null;
                this.dadosPlanilha[tipoRcf].tipoDeFranquia = null;
                this.dadosPlanilha[tipoRcf].percAjusteVmrOuVd = null;
                this.dadosPlanilha[tipoRcf].tipoDeContratacao = null;
                this.dadosPlanilha[tipoRcf].vlrCarroceria = null;
                this.dadosPlanilha[tipoRcf].descrCarroceria = null;
                this.dadosPlanilha[
                  tipoRcf
                ].coberturaAdicionalCarroceria = false;
                this.dadosPlanilha[tipoRcf].vlrEquipamentos = null;
                this.dadosPlanilha[tipoRcf].descrEquipamentos = null;
                this.dadosPlanilha[
                  tipoRcf
                ].coberturaAdicionalEquipamentos = false;
                this.dadosPlanilha[tipoRcf].vlrAcessorios = null;
                this.dadosPlanilha[tipoRcf].descrAcessorios = null;
                this.dadosPlanilha[
                  tipoRcf
                ].coberturaAdicionalAcessorios = false;
              }
            }
          }
        }
      } else if (
        this.selecaoIdOpcaoAlteracaoLote ===
        opcoesAlteracaoLote.opcoesAlteracaoLoteEnum.KM_ASSISTENCIA
      ) {
        for (
          var kmAssistencia = 0;
          kmAssistencia < this.dadosPlanilha.length;
          kmAssistencia++
        ) {
          for (var itemSelecionadoAlteracao of this
            .listaSelecionadoAlteracaoLote) {
            if (
              this.dadosPlanilha[kmAssistencia].item == itemSelecionadoAlteracao
            ) {
              for (var opcaoKmAssistencia of this
                .agrupamentoOpcoesAlteracaoLoteModel.opcaoKmAssistencia) {
                if (
                  opcaoKmAssistencia.id === this.idKmAssistenciaAlteracaoLote
                ) {
                  this.dadosPlanilha[kmAssistencia].kmAssistencia = {
                    id: this.idKmAssistenciaAlteracaoLote,
                    titulo: opcaoKmAssistencia.titulo
                  };
                }
              }
            }
          }
        }
      } else if (opcoesAlteracaoLote.campoDaOpcao(this.selecaoIdOpcaoAlteracaoLote)) {
        opcoesAlteracaoLote.aplicarValorEmLote(
          this.dadosPlanilha,
          this.listaSelecionadoAlteracaoLote,
          opcoesAlteracaoLote.campoDaOpcao(this.selecaoIdOpcaoAlteracaoLote),
          this.novoValorAlteracaoLote
        );
      }

      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Lote alterado com sucesso.";
      this.fecharDialogAlteracaoLote();
    },
    fecharDialogAlteracaoLote() {
      this.$refs.novoValorCampo.$el.getElementsByTagName("input")[0].value = 0;
      this.$refs.novoValorCampoVdContratado.$el.getElementsByTagName(
        "input"
      )[0].value = 0;
      this.listaSelecionadoAlteracaoLote = [];
      this.habilitaStepTipoCobertura = false;
      this.habilitarOpcaoContratacao = false;
      this.habilitarOpcaoPercentual = false;
      this.habilitarOpcaoGU = false;
      this.habilitarOpcaoFranquiaGU = false;
      this.habilitarOpcaoFranquiaDM = false;
      this.selecionarIdOpcaoGu = null;
      this.selecaoIdOpcaoAlteracaoLote = null;
      this.novoValorAlteracaoLote = null;
      this.novoValorAlteracaoLoteFiltrado = null;
      this.novoValorAlteracaoLoteVdContratado = null;
      this.novoValorAlteracaoLoteVdContratadoFiltrado = null;
      this.vlrOpcaoValorFranquiaGu = null;
      this.vlrOpcaoValorFranquiaDm = null;
      this.dialogConfirmarAlteracaoLote = false;
      this.dialogAlterarLote = false;
      this.stepAlterarItemLote = 1;
      this.idTipoCoberturaAlteracaoLote = null;
      this.idTipoContratacaoAlteracaoLote = null;
      this.idTipoFranquiaAlteracaoLote = null;
      this.idKmAssistenciaAlteracaoLote = null;
      this.habilitaStepKmAssistencia = false;
      this.novoValorPercentual = null;
    },
    selectionarTodosItensAlteracaoLote() {
      this.$store.commit("startLoading");

      this.$nextTick(() => {
        if (this.igualTodosItens) {
          this.listaSelecionadoAlteracaoLote = [];
        } else {
          const listagemItens = this.listaItensAlterarLote.slice();
          for (var listagemIten of listagemItens) {
            this.listaSelecionadoAlteracaoLote.push(listagemIten.id);
          }
        }
      });
      this.$store.commit("endLoading");
    },
    criarListaItensAlteracaoLote() {
      this.$store.commit("startLoading");
      for (var item of this.dadosPlanilha) {
        let id = item.item;
        let titulo =
          item.item < 10 ? `Item 0${item.item}` : `Item ${item.item}`;
        const objectoItem = { id: id, titulo: titulo };
        this.listaItensAlterarLote.push(objectoItem);
      }
      this.$store.commit("endLoading");
    },
    findArrayIndex(item) {
      return this.dadosPlanilha.findIndex(element => element.item == item);
    },
    disableCamposCarroceria(item, ativo) {
      if (!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].descrCarroceria = null;
        this.dadosPlanilha[this.findArrayIndex(item)].vlrCarroceria = null;
      }
    },
    disableCamposEquipamentos(item, ativo) {
      if (!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].descrEquipamentos = null;
        this.dadosPlanilha[this.findArrayIndex(item)].vlrEquipamentos = null;
      }
    },
    disableCamposAcessorios(item, ativo) {
      if (!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].descrAcessorios = null;
        this.dadosPlanilha[this.findArrayIndex(item)].vlrAcessorios = null;
      }
    },
    disableCamposDepesasExtras(item, ativo) {
      if (!ativo) {
        this.dadosPlanilha[this.findArrayIndex(item)].despesasExtras = null;
      } else {
        despesasExtrasHelper.aplicarValorFixo(
          this.dadosPlanilha[this.findArrayIndex(item)],
          this.limitesTaxasBasicas.valorFixoDespesasExtras
        );
      }
    },
    disableCamposDmADirigentes(item, ativo) {
      if (!ativo) {
        this.dadosPlanilha[
          this.findArrayIndex(item)
        ].vlrDmDirigenteSociosEmpregadosPrepostos = null;
      }
    },
    disableCamposDcADirigentes(item, ativo) {
      if (!ativo) {
        this.dadosPlanilha[
          this.findArrayIndex(item)
        ].vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos = null;
      }
    },
    saveCarroceria(item, ativo) {
      this.save();
      this.disableCamposCarroceria(item, ativo);
    },
    saveEquipamentos(item, ativo) {
      this.save();
      this.disableCamposEquipamentos(item, ativo);
    },
    saveAcessorios(item, ativo) {
      this.save();
      this.disableCamposAcessorios(item, ativo);
    },
    saveDespesasExtras(item, ativo) {
      this.save();
      this.disableCamposDepesasExtras(item, ativo);
    },
    saveDmDiregentes(item, ativo) {
      this.save();
      this.disableCamposDmADirigentes(item, ativo);
    },
    saveDcDiregentes(item, ativo) {
      this.save();
      this.disableCamposDcADirigentes(item, ativo);
    },
    getTipoEndosso(idTipoEndosso) {
      if (idTipoEndosso == 1) return "COBRANÇA";
      else if (idTipoEndosso == 2) return "EXCLUSÃO";
      else if (idTipoEndosso == 3) return "SEM MOVIMENTAÇÃO";
      else if (idTipoEndosso == 4) return " CANCELAMENTO";
    },
    formatarErro(novosErros, listaErros = {}) {
      return {
        ...listaErros,
        ...novosErros.reduce(
          (acc, cur) => ({ ...acc, [cur.item]: cur.erro }),
          {}
        )
      };
    },
    totaisCalculados() {
      const totais = this.$store.getters["formEndosso/totais"]

      if((totais == null || totais.totalPremio == 0 || totais.totalPremio == null || this.recalcular || (this.idStatusEndosso != null && this.idStatusEndosso == 1 ) )
          && !(this.idStatusEndosso == 5 && this.idTipoEndosso == 3)) {
        this.solicitaCalculo();

        return this.resultados
      }
      this.resultados = {...totais};
      this.dialogCalculo = true;
    },
    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "numeric",
        day: "numeric"
      });
    },
    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },

    buscarTitulo(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          item => item.id === entity || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    comparador(itemLista, item) {
      if (item && item.id !== null && item.id !== undefined) {
        return item.id === itemLista.id;
      }
      return false;
    },

    deletarItens() {
      const selecionados = this.selected.map(e => e.item);
      this.dadosPlanilha = this.dadosPlanilha.filter(
        e => !selecionados.includes(e.item)
      );
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dadosPlanilha.slice();
    },
    filtroFunctions: function() {
      const self = this;
      return {
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        }
      };
    },
    buscaOpcoes() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          [
            "tipoVeiculoList",
            "catVeiculoList",
            "ufPernoiteList",
            "usoDoVeiculoList",
            "propriedadeRegistroDoCrlvList",
            "diasGarantZeroKmList",
            "tipoCoberturaList",
            "tipoDeContratacaoList",
            "tipoDeFranquiaList",
            "tipoDePropostaList",
            "ciaRenovacaoList",
            "kmAssistenciaList",
            "carroReservaList",
            "descrCarroceriaList",
            "descrEquipamentosList",
            "descrAcessoriosList",
            "coberturaVidrosList",
            "vlrFranquiaDanosMateriaisList",
            "vlrFranquiaGarantiaUnicaList"
          ].forEach(nome => {
            this.campos[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
          this.campos.coberturaVidrosList = coberturaVidrosHelper.comOpcaoNenhuma(
            this.campos.coberturaVidrosList
          );
          this.normalizarVidrosTodosItens();
        })
        .catch(err => {
          console.error(err);
        });
    },

    solicitaCalculo() {
      this.normalizarVidrosTodosItens();
      if (!this.validaColunas()) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText =
          "Não foi possível calcular porque há valores fora da faixa permitida. Corrija os campos em vermelho e tente novamente.";
      } else {
        var dadosEndosso = this.$store.getters["formEndosso/dadosEndosso"];
        const dadosAtualizados = {
          dados: this.dadosPlanilha,
          dateInicio: this.dateInicio,
          idTipoEndosso: this.idTipoEndosso
        };
        for (var item of dadosAtualizados.dados) {
          if (item.garantiaUnica === null) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText =
              `[Erro no item: ${item.item}]: Campo garantia única inválido. Deve estar preenchido com SIM ou NÃO.`;
            return
          }
          if (item.tipoDeContratacao && item.tipoDeContratacao.id === 2 && item.vdContratado !== null || item.tipoCobertura.id === 3 && item.vdContratado !== null) {
            item.vdContratado = null;
          }
          if (item.tipoCobertura.id === 1 && (item.tipoDeContratacao === null || !item.percAjusteVmrOuVd || item.tipoDeFranquia === null)) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText =
              `[Erro no item: ${item.item}] Para cobertura Compreensiva, campos 'Tipo de Contratação', '% Ajuste VMR/VD' e 'Tipo de Franquia' devem estar preenchidos.`;
            return
          }
          if (item.tipoCobertura.id === 1 && item.tipoDeContratacao && item.tipoDeContratacao.id === 1 &&
            (!item.percAjusteVmrOuVd || item.tipoDeFranquia === null || item.vdContratado === null)) {
              this.snack = true;
              this.snackColor = "error";
              this.snackText =
                `[Erro no item: ${item.item}] Para cobertura Compreensiva de tipo VD, os campos '% Ajuste VMR/VD', 'Tipo de Franquia' e 'VD Contratado' devem estar preenchidos.`;
              return
          }
          if (item.garantiaUnica === false && item.guDmDcADirigentesSociosEmpregadosEPrepostos === true) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText =
            `[Erro no cálculo do item: ${item.item}] Garantia Única não contratado, impossibilitando o cálculo para GU DM/DC a Dirigentes, Sócios, Empregados e Prepostos.`;
            return
          }
          if (item.rcfExtCobAmericaDoSul === true) {
            const danosMateriaisValidos = item.danosMateriais > 0;
            const danosCorporaisValidos = item.danosCorporais > 0;
            const garantiaUnicaValida = item.garantiaUnica && item.vlrGarantiaUnica > 0;

            if (!danosMateriaisValidos && !danosCorporaisValidos && !garantiaUnicaValida) {
              this.snack = true;
              this.snackColor = "error";
              this.snackText =
              `[Erro no cálculo do item: ${item.item}] A cobertura 'RCF - Extensão de Cobertura de Perímetro do Seguro aos Países da América do Sul' foi contratada. Informe pelo menos um valor para Danos Materiais, Danos Corporais ou Garantia Única para prosseguir.`;
              return
            }
        }
      }

        var requestBody =  {
          ...this.$store.getters["formEndosso/requisicaoEndossoAdicionar"],
          listaCondicaoComercialEspecial: this.$store.getters["formEndosso/infoEndosso"].listaCondicaoComercialEspecial,
          listaCondicaoComercialEspecialModificacao: this.$store.getters["formEndosso/infoEndosso"].listaCondicaoComercialEspecialModificacao
        };

        this.loaderPagina = true;
        this.$store.commit("formEndosso/setItensAdicionados", dadosAtualizados);
        axios
          .post(
            `${process.env.URL_ENDOSSOMS}/v1/calcularEndosso/${this.idApolice}`,
            requestBody,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          )
          .then(response => {
            this.loaderPagina = false;
            Object.keys(this.resultados).forEach(item => {
              this.resultados[item] = response.data[item];
            });
            this.dialogCalculo = true;
          })
          .catch(error => {
            this.loaderPagina = false;
            this.snack = true;
            this.snackColor = "error";
            error.response.data.message
              ? (this.snackText = error.response.data.message)
              : (this.snackText = "generico");
          });
      }
    },

    async buscaLimitesTaxas() {
      const respostaLimitesTaxas = await axios.post(
        `${process.env.URL_CALCULOMS}/v1/limitesTaxasBasicas`,

        this.dadosPlanilha
          .filter(veiculo => veiculo.catVeiculo && veiculo.catVeiculo.id !== 6)
          .map(veiculo =>
            ["item", "fipe", "anoMod", "tipoVeiculo"].reduce((acc, cur) => {
              acc[cur] = veiculo[cur];

              return acc;
            }, {})
          ),
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      if (respostaLimitesTaxas.data) {
        this.limitesTaxasBasicas = respostaLimitesTaxas.data;
        despesasExtrasHelper.aplicarValorFixo(
          this.dadosPlanilha,
          this.limitesTaxasBasicas.valorFixoDespesasExtras
        );
      }
    },

    validaColunas() {
      return Object.values(this.erros).every(item =>
        Object.values(item).every(subItem => subItem.erro !== true)
      );
    },

    voltar: function() {
      if (this.idTipoEndosso == 5) {
        this.$router.push(
          `/GridPrincipal/GridEndossoVeiculoSubstituicao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      } else if (this.numeroRevisao) {
        this.$router.push(
          `/GridPrincipal/GridEndossoVeiculos?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&numeroRevisao=${this.numeroRevisao}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else {
        this.$router.push(
          `/GridPrincipal/GridEndossoVeiculos?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      }
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Editar cancelado";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Editar aberto";
    },
    close() {},

    limiteExcedido({ min, max }, value) {
      if (min === undefined || max === undefined) {
        return;
      }

      return +value !== 0 && (value < min || value > max);
    },
    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    }
  }
};
</script>

<style scoped>
  .background {
    background-color: white;
  }

  .item-primary .v-menu__activator {
    display: flex;
    justify-content: center;
    text-align: center !important;
  }

  .item-color > div > a {
    color: #757575 !important;
  }

  .errorTaxa {
    color: red !important;
    font-weight: bold;
  }

  .button-permanecer {
    background: #00456e;
    color: #fff !important;
  }

  .text-permanecer {
    font-weight: bold;
    color: #757575 !important;
  }

  .dialog-alterar-lote {
    border-radius: 10px;
  }

  .alterar-lote-titulo.headline {
    font-size: 24px !important;
  }

  .alterar-lote-titulo {
    color: white !important;
    background-color: #00456e;
  }

  .GridVeiculos .v-list__tile__title {
    padding-bottom: 35px !important;
  }

  .content-confirmacao {
    color: #757575;
    font-size: 14px;
    font-weight: bold;
  }

  .text-align-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/CoberturaEndosso.vue